import { Plugin, PluginKey } from "prosemirror-state";
import { ReactPluginView } from "../../../react/react-plugin-view";
import { EditorVideoMenuPluginView } from "../components/EditorVideoMenuPluginView/EditorVideoMenuPluginView";
const videoMenuPluginKey = new PluginKey();
export function videoMenuPlugin(portalContainer, filestackService) {
    return new Plugin({
        key: videoMenuPluginKey,
        state: {
            init: () => null,
            apply: (tr, state) => {
                if (tr.getMeta(videoMenuPluginKey) !== undefined) {
                    return tr.getMeta(videoMenuPluginKey);
                }
                return state;
            },
        },
        view: (view) => new ReactPluginView(view, {
            portalContainer,
            component: EditorVideoMenuPluginView,
            extraProps: {},
        }),
    });
}
export function setVideoMenuState(tr, state) {
    return tr.setMeta(videoMenuPluginKey, state);
}
export function getVideoMenuState(state) {
    return videoMenuPluginKey.getState(state);
}
let hideVideoMenuTimeout;
export function showVideoMenu(view, target = null) {
    if (hideVideoMenuTimeout) {
        window.clearTimeout(hideVideoMenuTimeout);
    }
    if (target) {
        view.dispatch(setVideoMenuState(view.state.tr, {
            target,
            pos: view.posAtDOM(target, 0),
        }));
    }
}
export function hideVideoMenu(view) {
    if (hideVideoMenuTimeout) {
        window.clearTimeout(hideVideoMenuTimeout);
    }
    hideVideoMenuTimeout = window.setTimeout(() => {
        view.dispatch(setVideoMenuState(view.state.tr, null));
    }, 200);
}
